function initCustomSaleBadges() {
    const productCards = document.querySelectorAll('.grid__item');

    productCards.forEach(card => {
        card.querySelector('.card__badge.top.right .discount-badge')?.remove();
        if (card.querySelector('.discount-badge.bss')) return;

        const imgWrapper = card.querySelector('.card__badge.top.right .badge');
        if (!imgWrapper) return;

        const priceBox = card.querySelector('.card-information .price[bss-b2b-collection-element]');
        if (!priceBox) return;

        const priceSpans = priceBox.querySelectorAll('span');

        let originalPrice = 0;
        let salePrice = 0;

        if (priceSpans.length >= 2) {
            originalPrice = parseFloat(
            priceSpans[0].textContent.replace(/[^0-9.]/g, '')
            );
            salePrice = parseFloat(
            priceSpans[1].textContent.replace(/[^0-9.]/g, '')
            );
        }

        console.log(originalPrice, salePrice);

        if (originalPrice > 0 && salePrice > 0 && originalPrice > salePrice) {
            const discountPercentage = Math.round(
                ((originalPrice - salePrice) / originalPrice) * 100
            );

            if (discountPercentage > 0) {
                const badge = document.createElement('span');
                badge.className = 'discount-badge bss';
                badge.innerText = ` ${discountPercentage}% OFF `;

                imgWrapper.appendChild(badge);
            }
        }
    });
}

let counter = 0;
let selector = '.price[bss-b2b-collection-element] span[style="text-decoration: line-through; margin-right: 10px; color: #303030;"]'
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);
        initCustomSaleBadges()
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 